import React, { useEffect, useState } from 'react';
import woodBtnSrc from './image/woodBtn.png'
import kiImage from './image/ki.png';
import kojaImage from './image/koja.png';
import chiImage from './image/shop.png';
import './Home.css';
import { useHistory } from 'react-router-dom';
import socket from '../../service/socket';
import { getCookie, getUid } from './../../service/authCookie';
import { checkVisit } from './../../service/checkVisit';
import { Helmet } from 'react-helmet';

const Home = () => {
    const [mode, setMode] = useState(1);
    const history = useHistory();

    useEffect(()=> {
        socket.emit("viewMessage", {
            location: window.location.href,
            authenticated: getCookie(),
            UID : getCookie() ? getUid() : null
        }, (response) => {
            if(response && response.status === 'New')
            checkVisit(response.uId)
        });
    },[]);

    return ( 
        <div className="home-layer">
            <Helmet>
                <title>3 دان | صفحه اصلی ، کی خوبه ؟ ، کجا خوبه ؟ ، چی داری ؟</title>
            </Helmet>
            <div className="bold-items">
                <div 
                    className={`woodBtn-item ${mode === 1 && 'woodBtn-item-active'}`}
                    onClick={() => setMode(1)}
                >
                    <div className="iii">
                        <img className="img-fluid" src={woodBtnSrc} alt=""/>
                        <label>
                            <img src={kiImage} alt="" className="main-3image"/>
                            کی خوبه ؟
                        </label>
                    </div>
                </div>
                <div 
                    className={`woodBtn-item ${mode === 2 && 'woodBtn-item-active'}`}
                    onClick={() => setMode(2)}
                >
                    <div className="iii">
                        <img className="img-fluid" src={woodBtnSrc} alt=""/>
                        <label>
                            <img src={kojaImage} alt="" className="main-3image"/>
                            کجا خوبه ؟
                        </label>
                    </div>
                </div>
                <div 
                    className={`woodBtn-item ${mode === 3 && 'woodBtn-item-active'}`}
                    onClick={() => setMode(3)}
                >
                    <div className="iii">
                        <img className="img-fluid" src={woodBtnSrc} alt=""/>
                        <label>
                            <img src={chiImage} alt="" className="main-3image"/>
                            فروشگاه
                        </label>
                    </div>
                </div>
            </div>
            <div className="container">
                {
                    mode === 1 &&
                    <section className="main-items-info">
                        <img src={kiImage} alt="" />
                        <div className="text-dark">
                            <h5>کی خوبه ؟</h5>
                            <h6>« تأسیسات ، تعمیرات »</h6>
                            <p className="text-justify">
                                اگر به دنبال افراد متخصص در هر شغلی میگردی
                                (مثل بنایی ، کاشی کاری ، برق کاری ، نجاری ، تعمیرکار لوازم برقی و ... ) ، 
                                میتونی بهترین افراد رو در هر زمینه ای 
                                که خواستی تو وبسایت ما پیدا کنی.
                                ما بهترین افراد با کمترین هزینه رو به منزل شما
                                میفرستیم و در حین انجام کار نظارت لازم رو به عمل میاریم 
                                تا هم کیفیت هم کمیت کار رعایت شود
                            </p>
                            <div className="text-center">
                                <button 
                                    className="btn btn-success outline"
                                    style={{width:'130px'}}
                                    onClick={() => history.push('/who')}
                                >
                                    جستجو و مشاهده
                                </button>
                            </div>
                        </div>
                    </section>
                }
                { 
                    mode === 2 && 
                    <section className="main-items-info">
                        <img src={kojaImage} alt="" />
                        <div className="text-dark">
                            <h5>کجا خوبه ؟</h5>
                            <h6>« فروشگاه ، آرایشگاه ، آموزشگاه و ... »</h6>
                            <p className="text-justify">
                                اگه دنبال فروشگاه های شهر برای خرید کردن میگردی و یا میخوای
                                بدونی مکان های تفریحی کجاست و یا هر جای دیگه ای رو میخوای پیدا کنی 
                                (مثل آرایشگاه ها ، آموزشگاه ها ، فروشگاه ها ، مکان های تفریحی
                                مکان های زیارتی و ...)
                                 میتونی توی وبسایت ما جستجو کنی و ببینی. 
                            </p>
                            <div className="text-center">
                                <button 
                                    className="btn btn-success outline"
                                    style={{width:'130px'}}
                                    onClick={() => history.push('/where')}
                                >
                                    جستجو و مشاهده
                                </button>
                            </div>
                        </div>
                    </section>
                
                }
                {
                    mode === 3 &&
                    <section className="main-items-info">
                        <img src={chiImage} alt="" />
                        <div className="text-dark">
                            <h5>فروشگاه</h5>
                            <h6>
                                مواد غذایی ، سبزیجات ، لوازم ساختمانی و ...
                            </h6>
                            <p>
                                برای تهیه لوازم و مواد غذایی مصرفی خود با بهترین کیفیت و کمترین قیمت ، به 
                                فروشگاه آنلاین ما وارد شوید ، پس از انتخاب و سفارش کلیه سفارشات شما
                                توسط پیک ارسال خواهد شد .
                            </p>
                            {/* <h6>«ضایعات فلزی ، پلاستیکی ، لوازم کهنه و ... »</h6>
                            <p className="text-justify">
                                لوازم کهنه و ضایعات پلاستیکی ، فلزی و ... خودتون رو دور نیندازید.
                                ما ضایعات شما رو درب منزل از شما خریداری میکنیم. 
                                برای این منظور فقط کافیه عکس از ضایعات موجود بگیرین
                                و برای ما بفرستین تا ما در اولین فرصت از درب منزل
                                ضایعات موجود شما رو خریداری کنیم.
                                
                            </p> */}

                            <div className="text-center">
                                <button 
                                    className="btn btn-success outline"
                                    style={{width:'130px'}}
                                    onClick={() => history.push('/shop')}

                                >
                                    فروشگاه آنلاین
                                </button>
                            </div>
                        </div>
                    </section>

                }
            </div>
            <div className='alert alert-success m-4 mx-auto text-center' style={{maxWidth:'650px'}}>
                <b className=''>
                    تمامی ضایعات کاغذی ، پلاستیکی و آهن آلات منزل شما را خریداریم
                </b>
                <div className="text-center">
                    <button 
                        className="btn btn-dark outline p-0 mt-2"
                        style={{width:'130px', height:'30px'}}
                        onClick={() => history.push('/what')}
                    >
                        کلیک کنید
                    </button>
                </div>
            </div>
        </div>
     );
}
 
export default Home;